import { Box, Typography, Button, Container, Divider } from "@mui/material"
import { motion } from "framer-motion"

const RaviniasVault = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #0f2027, #203a43, #2c5364)",
        color: "white",
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" gutterBottom sx={{ fontWeight: 700 }}>
            Ravinia’s VAULT
          </Typography>
          <Divider sx={{ my: 2, backgroundColor: "#00e676" }} />
          <Typography variant="h6" paragraph sx={{ maxWidth: 700 }}>
            The <strong>Vital Alliance for Urban Leadership Trust</strong> — our neighborhood's nonprofit reinvestment engine.
            We're building a movement to reinvest private dollars into our own streets, businesses, and community culture.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <Box mt={4}>
            <Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.7 }}>
              Through Ravinia’s VAULT, residents and property owners can donate in tax-smart ways, fueling:
            </Typography>
            <ul style={{ marginTop: 16, paddingLeft: 20 }}>
              <li>Storefront restorations</li>
              <li>ADA upgrades</li>
              <li>Landlord investment incentives</li>
              <li>District-wide cultural projects</li>
            </ul>
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.6 }}
        >
          <Box mt={6} textAlign="center">
            <Button
              variant="contained"
              size="large"
              href="/contact"
              sx={{
                backgroundColor: "#00e676",
                color: "#000",
                fontWeight: 600,
                borderRadius: "30px",
                px: 5,
                "&:hover": {
                  backgroundColor: "#00c853",
                },
              }}
            >
              Join the Movement
            </Button>
            <br />
            <Button
              variant="contained"
              size="large"
              href="https://raviniasvault.org"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#fff",
                color: "#00c853",
                fontWeight: 700,
                borderRadius: "30px",
                px: 5,
                py: 2,
                mt: 3,
                boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              Visit Ravinia's Vault Website
            </Button>
            <a
              href="/assets/10-Year_Economic_Projection.pdf"
              download
              style={{
                display: "inline-block",
                marginTop: "24px",
                background: "#fff",
                color: "#00c853",
                fontWeight: 600,
                borderRadius: "30px",
                padding: "12px 40px",
                textDecoration: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                transition: "background 0.2s",
              }}
            >
              Download Economic Projection PDF
            </a>
            <Box mt={4}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  color: "#00e676",
                  letterSpacing: 1,
                  mb: 1,
                  fontSize: "1.2rem",
                  textShadow: "0 2px 8px rgba(0,0,0,0.18)",
                }}
              >
                For the People
              </Typography>
              <a
                href="/assets/V2_Give_Where_You_Live.pdf"
                download
                style={{
                  display: "inline-block",
                  background: "#fff",
                  color: "#00c853",
                  fontWeight: 600,
                  borderRadius: "30px",
                  padding: "12px 40px",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "background 0.2s",
                }}
              >
                Give Where You Live
              </a>
            </Box>
            <Box mt={4}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  color: "#00e676",
                  letterSpacing: 1,
                  mb: 1,
                  fontSize: "1.2rem",
                  textShadow: "0 2px 8px rgba(0,0,0,0.18)",
                }}
              >
                For the Landlords
              </Typography>
              <a
                href="/assets/V2_The_Big_PAYBACK.pdf"
                download
                style={{
                  display: "inline-block",
                  background: "#fff",
                  color: "#00c853",
                  fontWeight: 600,
                  borderRadius: "30px",
                  padding: "12px 40px",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "background 0.2s",
                }}
              >
                The Big PAYBACK!
              </a>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  )
}

export default RaviniasVault
